var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgMmSparkles28 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0107 14.4039L25.9995 12.6841L21.0107 10.9642L19.3478 5.80469L17.6848 10.9642L12.696 12.6841L17.6848 14.4039L19.3478 19.5635L21.0107 14.4039Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.42386 21.6278L12.2782 20.2991L8.42386 18.9704L7.13909 14.9841L5.85432 18.9704L2 20.2991L5.85432 21.6278L7.13909 25.614L8.42386 21.6278Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.12227 6.69765L11.0697 5.68156L8.12227 4.66547L7.13979 1.61719L6.15732 4.66547L3.2099 5.68156L6.15732 6.69765L7.13979 9.74594L8.12227 6.69765Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMmSparkles28);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;